import $ from 'jquery';

$.addInit(function(context){
	var base = '.b-address';
	$(base, context).each(function(){
		var component = $(this);
		var panels = component.find('.b-tabs-panel');
		var scrolls = panels.find('.b-customScroll');

		panels.on('active', function() {
			scrolls.trigger('refresh');
		});
	});
});



//////////////////
// WEBPACK FOOTER
// ./src/components/b-address.js
// module id = 31
// module chunks = 0